module.exports = __webpack_public_path__ + "static/media/apti_space_MVP_v2.c0cde162.jpg";